import React from 'react'
import ButtonUI from '../../widgets/action/ButtonUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import PhoneUpdateStep1SF from '../../components/userSettings/PhoneUpdateStep1SF'
import PhoneUpdateStep2SF from '../../components/userSettings/PhoneUpdateStep2SF'

const PhoneUpdatePageUI = ({ context, messageList, onUpdatePhoneComplete,
  // old phone number
  oldPhoneNumber, onOldPhoneNumberChange, oldPhoneNumberError, setOldPhoneNumberError,
  // new phone number
  newPhoneNumber, onNewPhoneNumberChange, newPhoneNumberError, setNewPhoneNumberError,
  // verification code
  verifCode, onVerifCodeChange, verifCodeError, setVerifCodeError,
  // view
  view, setView }) =>
  <PublicPageSF context={context} className='pg_upd_phone' backLink='/' centered={!messageList}
    messageList={messageList} headerMessageKey='c_update_phone_number'>
    {
      !messageList &&
      <SpinnerComponentUI />
    }
    {
      messageList && view === 'phoneNumber' &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/settings/user/fin'
          messageList={messageList} titleMessageKey='c_update_phone_number' />

        <PhoneUpdateStep1SF context={context} oldPhoneNumber={oldPhoneNumber}
          onOldPhoneNumberChange={onOldPhoneNumberChange} oldPhoneNumberError={oldPhoneNumberError}
          setOldPhoneNumberError={setOldPhoneNumberError} newPhoneNumber={newPhoneNumber}
          onNewPhoneNumberChange={onNewPhoneNumberChange} newPhoneNumberError={newPhoneNumberError}
          setNewPhoneNumberError={setNewPhoneNumberError} setView={setView} />
      </React.Fragment>
    }
    {
      messageList && view === 'verification' &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={false} messageList={messageList} titleMessageKey='c_verify_new_phone' />

        <PhoneUpdateStep2SF context={context} newPhoneNumber={newPhoneNumber}
          onNewPhoneNumberChange={onNewPhoneNumberChange} newPhoneNumberError={newPhoneNumberError}
          setNewPhoneNumberError={setNewPhoneNumberError} verifCode={verifCode}
          onVerifCodeChange={onVerifCodeChange} verifCodeError={verifCodeError}
          setVerifCodeError={setVerifCodeError} onUpdatePhoneComplete={onUpdatePhoneComplete}
          setView={setView} />

        <div className='g_m_top_100'>
          <ButtonUI context={context} messageList={messageList} labelKey='c_re_update_phone'
            onClick={() => { setView('phoneNumber'); }} transparent={true}
          />
        </div>
      </React.Fragment>
    }

  </PublicPageSF>

export default PhoneUpdatePageUI
